import { BackspaceReverseOutlineIcon } from './BackspaceReverseOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 287700E2-130D-484B-B56D-0162BE6DEEEE
 * name backspace-reverse-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/backspace-reverse-outline.svg
 * tags
 */
export const ClearReverseOutlineIcon = BackspaceReverseOutlineIcon;
export default ClearReverseOutlineIcon